module.exports = __webpack_public_path__ + "media/images/fake/006-1d973ffd578fa6bcbcc136b7c4d839ed.jpg";